import { useQuery } from "react-query";
import { getOfficeBank } from "../../../../../actions/Utilities/OfficeBank";

export default function useGetOfficeBank() {
  return useQuery("GetOfficeBank", getOfficeBank, {
    refetchOnWindowFocus: false,
  });
}